<template>
  <!-- Canali di notifica (pattern .settings-card): consenso e-mail, interruttori
       e-mail e push come righe di lista, poi il canale Telegram. Una sola
       card come radice, così funziona dentro .settings-pair e .settings-grid;
       con Telegram le due colonne sono un .settings-pair interno. -->
  <section class="shadowedCard p-4 settings-card">
    <div class="section-head mb-3">
      <b-icon icon="bell" class="section-head__icon" aria-hidden="true"></b-icon>
      <h2 class="section-title mb-0">{{ $t('NotificationChannels.accessi_notifiche') }}</h2>
    </div>
    <p class="settings-card__lead">{{ $t('NotificationChannels.descrizione_accessi') }}</p>

    <div :class="{ 'settings-pair': bots }">
      <div>
        <p class="section-eyebrow mb-2">{{ $t('NotificationChannels.notifiche_email1') }}</p>
        <div class="list-stack">
          <div class="list-row">
            <span
              class="list-row__icon"
              :class="user.canale_notifica_email_consense ? 'list-row__icon--ok' : 'list-row__icon--no'"
              aria-hidden="true"
            >
              <b-icon :icon="user.canale_notifica_email_consense ? 'check-lg' : 'x-lg'"></b-icon>
            </span>
            <div class="list-row__body">
              <p class="list-row__title mb-0">
                {{ user.canale_notifica_email_consense ? $t('NotificationChannels.consenso_email') : $t('NotificationChannels.no_consenso_email') }}
                <a target="_blank" class="text-underlined" :href="user.type == 1 ? privacyPolicyLinks.operatore : privacyPolicyLinks.paziente">{{ $t('NotificationChannels.informativa_privacy') }}</a>
              </p>
            </div>
            <b-button size="sm" variant="outline-secondary" @click="$bvModal.show('email-consense-modal')">
              {{ $t('NotificationChannels.modifica') }}
            </b-button>
          </div>
          <div class="list-row" v-if="user.canale_notifica_email_consense">
            <span class="list-row__icon" aria-hidden="true"><b-icon icon="envelope"></b-icon></span>
            <div class="list-row__body">
              <p class="list-row__title mb-0">{{ $t('NotificationChannels.notifiche_email1') }}</p>
              <p class="list-row__meta mb-0">
                {{ $t('NotificationChannels.ricezione_notifiche') }}
                {{ mailEnabled == true ? $t('NotificationChannels.attiva') : $t('NotificationChannels.disattivata') }}
              </p>
            </div>
            <b-form-checkbox
              @change="editUserConsense(false)"
              v-model="mailEnabled"
              name="mail-active"
              :value="true"
              switch
              class="mb-0"
              :aria-label="$t('NotificationChannels.notifiche_email1')"
            ></b-form-checkbox>
          </div>
          <div class="list-row">
            <span class="list-row__icon" aria-hidden="true"><b-icon icon="phone"></b-icon></span>
            <div class="list-row__body">
              <p class="list-row__title mb-0">{{ $t('NotificationChannels.notifiche_push') }}</p>
              <p class="list-row__meta mb-0">
                <template v-if="user.push_token">
                  {{ $t('NotificationChannels.ricezione_notifiche') }}
                  {{ pushEnabled == true ? $t('NotificationChannels.attiva') : $t('NotificationChannels.disattivata') }}
                </template>
                <template v-else>{{ $t('NotificationChannels.consent_push') }}</template>
              </p>
            </div>
            <b-form-checkbox
              v-if="user.push_token"
              @change="editUserConsense(true)"
              v-model="pushEnabled"
              name="push-active"
              :value="true"
              switch
              class="mb-0"
              :aria-label="$t('NotificationChannels.notifiche_push')"
            ></b-form-checkbox>
          </div>
        </div>
      </div>

      <div v-if="bots">
        <p class="section-eyebrow mb-2">{{ $t('NotificationChannels.canale_telegram') }}</p>
        <div class="list-stack">
          <div v-for="(bot, ind) in bots['']" :key="'tg' + ind" class="list-row">
            <span class="list-row__icon" aria-hidden="true"><b-icon icon="telegram"></b-icon></span>
            <div class="list-row__body">
              <p class="list-row__title mb-0">{{ bot.bot_username }}</p>
              <p class="list-row__meta mb-0">
                {{ $t('NotificationChannels.ricezione_notifiche') }}
                {{ bot.active == true ? $t('NotificationChannels.attiva') : $t('NotificationChannels.disattivata') }}
              </p>
            </div>
            <b-form-checkbox
              @change="showModalConfirm(bot, false)"
              v-model="bot.active"
              :name="ind + 'active'"
              :value="1"
              switch
              class="mb-0"
              :aria-label="bot.bot_username"
            ></b-form-checkbox>
            <b-button
              variant="white"
              class="btn-icon btn-sm text-danger"
              v-b-tooltip.hover
              :title="$t('NotificationChannels.rimuovi_accesso')"
              :aria-label="$t('NotificationChannels.rimuovi_accesso')"
              @click="showModalConfirm(bot, true)"
            >
              <b-icon icon="trash" aria-hidden="true"></b-icon>
            </b-button>
          </div>
          <div v-if="!bots[''] || bots[''].length < 1" class="empty-state">
            <b-icon icon="telegram" class="empty-state__icon" aria-hidden="true"></b-icon>
            <p>{{ $t('NotificationChannels.nessun_accesso') }}</p>
            <b-button :href="tgLink" target="_blank" variant="outline-secondary" size="sm">
              {{ $t('NotificationChannels.accedi_telegram') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="delete-access"
      :title="$t('NotificationChannels.elimina_accesso')"
      @cancel="resetDelete"
      @hidden="fetchData"
      @ok="handleOkDelete"
      button-size="sm"
      :cancel-title="$t('NotificationChannels.annulla')"
      cancel-variant="popup-button mr-2"
      :ok-title="$t('NotificationChannels.conferma')"
      ok-variant="popup-button"
      footer-class="border-0"
      centered
    >
      <template v-if="selectedBot">
        <h6>
          {{$t('NotificationChannels.vuoi_rimuovere')}} 
          {{ selectedBot.messenger == "WP" ? "whatsapp" : "telegram" }} {{$t('NotificationChannels.accesso_da')}}
          {{ selectedBot.bot_username }} ?
        </h6>
      </template>
    </b-modal>
    <b-modal
      id="update-access"
      :title="$t('NotificationChannels.modifica_stato')"
      @cancel="resetUpdate"
      @hidden="fetchData"
      @ok="handleOkUpdate"
      button-size="sm"
      :cancel-title="$t('NotificationChannels.annulla')"
      cancel-variant="popup-button mr-2"
      :ok-title="$t('NotificationChannels.conferma')"
      ok-variant="popup-button"
      footer-class="border-0"
      centered
    >
      <template v-if="selectedBot">
        <h6>
          {{$t('NotificationChannels.vuoi')}} {{ selectedBot.active == true ? $t('NotificationChannels.attivare') : $t('NotificationChannels.disattivare') }}
          {{$t('NotificationChannels.notifiche_messenger')}} {{ selectedBot.messenger == "WP" ? "whatsapp" : "telegram" }}
          {{$t('NotificationChannels.da')}}
          {{ selectedBot.bot_username }}?
        </h6>
      </template>
    </b-modal>
    <b-modal
      id="update-consenses"
      :title="$t('NotificationChannels.conferma_operazione')"
      @cancel="cancelUpdateConsense"
      @ok="updateConsense"
      button-size="sm"
      :cancel-title="$t('NotificationChannels.annulla')"
      cancel-variant="popup-button mr-2"
      :ok-title="$t('NotificationChannels.conferma')"
      ok-variant="popup-button"
      footer-class="border-0"
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <template v-if="pushMessageAlert">
        <h6>
          {{$t('NotificationChannels.vuoi')}} {{ pushEnabled == true ? $t('NotificationChannels.attivare') : $t('NotificationChannels.disattivare') }}
          {{$t('NotificationChannels.notifiche_push')}}
        </h6>
      </template>
      <template v-else>
        <h6>
          {{$t('NotificationChannels.vuoi')}} {{ mailEnabled == true ? $t('NotificationChannels.attivare') : $t('NotificationChannels.disattivare') }}
          {{$t('NotificationChannels.notifiche_email')}}
        </h6>
      </template>
    </b-modal>
    <b-modal
      id="email-consense-modal"
      :title="$t('NotificationChannels.consenso_email_title')"
      :ok-title="$t('NotificationChannels.salva_modifiche')"
      :cancel-title="$t('NotificationChannels.annulla')"
      ok-variant="popup-button"
      cancel-variant="popup-button mr-2"
      footer-border-variant="white"
      @ok="updateConsense"
      @cancel="$bvModal.hide('email-consense-modal')"
      centered
    >
      <b-form-group>
        <b-form-radio-group v-model="emailConsense" name="email_options">
          <b-form-radio :value="true">
            {{$t('NotificationChannels.acconsento_email')}}
            <a
              target="_blank"
              class="text-underlined point"
              :href="
                user.type == 1
                  ? privacyPolicyLinks.operatore
                  : privacyPolicyLinks.paziente
              "
            >
              <u>{{$t('NotificationChannels.informativa_privacy')}}</u>
            </a>
          </b-form-radio>
          <b-form-radio :value="false" class="mt-3"> {{$t('NotificationChannels.non_accetto')}}</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
    </b-modal>
  </section>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { cittadinoService } from "@/_services";
export default {
  name: "NotificationChannels",
  data() {
    return {
      bots: null,
      mock: {
        bot_username: null,
        active: false,
        deleted_at: true,
      },
      selectedBot: null,
      pushMessageAlert: false,
      pushEnabled: false,
      mailEnabled: false,
      waLink: "https://wa.me/" + process.env.VUE_APP_WA_CHANNEL,
      tgLink: "https://t.me/" + process.env.VUE_APP_TG_CHANNEL,
      emailConsense: false,
      privacyPolicyLinks: {
        paziente: process.env.VUE_APP_LINK_INFORMATIVA_PAZIENTE,
        operatore: process.env.VUE_APP_LINK_INFORMATIVA_OPERATORE,
      },
    };
  },
  computed: {
    ...mapState({
      alert: (state) => state.alert,
    }),
    ...mapState("utente", ["status", "user"]),
  },
  methods: {
    ...mapActions({
      clearAlert: "alert/clear",
      errorAlert: "alert/error",
      successAlert: "alert/success",
      infoAlert: "alert/info",
    }),
    fetchData() {
      var self = this;
      cittadinoService
        .getUserBots()
        .then(function (res) {
          // console.log(res);
          self.bots = res.data.data;
        })
        .catch(function (err) {
          window.scrollTo(0, 0);
          self.errorAlert(self.$t('NotificationChannels.errore_accessi'))

        });
    },
    showModalConfirm(bot, doDelete) {
      this.selectedBot = bot;
      if (doDelete) {
        this.$bvModal.show("delete-access");
      } else {
        this.$bvModal.show("update-access");
      }
    },
    editUserConsense(push) {
      this.pushMessageAlert = push;
      this.$bvModal.show("update-consenses");
    },
    resetDelete() {
      this.selectedBot = null;
      this.$bvModal.hide("delete-access");
    },
    resetUpdate() {
      this.selectedBot = null;
      this.$bvModal.hide("update-access");
    },
    cancelUpdateConsense() {
      if (this.pushMessageAlert) {
        this.pushEnabled = !this.pushEnabled;
      } else {
        this.mailEnabled = !this.mailEnabled;
      }
    },
    handleOkDelete() {
      var self = this;
      cittadinoService
        .deleteBotAccess(this.selectedBot.hashid)
        .then(function (res) {
          window.scrollTo(0, 0);
          self.$bvModal.hide("delete-access");
          self.successAlert(self.$t('NotificationChannels.accesso_eliminato'))
          self.selectedBot = null;
        })
        .catch(function (err) {
          self.$bvModal.hide("delete-access");
          window.scrollTo(0, 0);
          self.errorAlert(self.$t('NotificationChannels.errore_eliminazione'))
        });
    },
    handleOkUpdate() {
      var self = this;
      var form = {
        active: this.selectedBot.active,
      };
      cittadinoService
        .updateUserBots(form, this.selectedBot.hashid)
        .then(function (res) {
          window.scrollTo(0, 0);
          self.$bvModal.hide("update-access");
          self.successAlert(self.$t('NotificationChannels.modifiche_successo'))
          self.selectedBot = null;
        })
        .catch(function (err) {
          window.scrollTo(0, 0);
          self.$bvModal.hide("update-access");
          self.errorAlert(self.$t('NotificationChannels.errore_modifiche'))
          self.selectedBot = null;
        });
    },
    updateConsense() {
      var self = this;
      var form = {
        push_consense: this.pushEnabled,
        notification_consense: this.mailEnabled,
        canale_notifica_email_consense: this.emailConsense,
      };
      cittadinoService
        .updateConsense(form)
        .then(function (res) {
          window.scrollTo(0, 0);
          self.$bvModal.hide("update-access");
          self.$bvModal.hide("email-consense-modal");
          self.user.canale_notifica_email_consense = self.emailConsense;
          self.successAlert(self.$t('NotificationChannels.modifiche_successo'))
          self.selectedBot = null;
        })
        .catch(function (err) {
          window.scrollTo(0, 0);
          self.$bvModal.hide("update-access");
          self.errorAlert(self.$t('NotificationChannels.errore_modifiche'))
          self.selectedBot = null;
        });
    },
  },
  watch: {
    emailConsense(newVal) {
      this.mailEnabled = newVal;
    },
  },
  created() {
    //TEMPORANEAMENTE DISATTIVATO
    // this.fetchData();
  },
  mounted() {
    this.pushEnabled = this.user.push_consense == true;
    this.mailEnabled = this.user.notification_consense == true;
    this.emailConsense = this.user.canale_notifica_email_consense == true;
  },
};
</script>
